/*eslint-disable */
import toast from '@/services/toast';
import presentationFileUpload from '@/components/presentation-file-upload/index.vue';
import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';
export default {
  name: 'presentation-file-list-page',
  components: {
    'presentation-file-upload':presentationFileUpload
  },
  props: [],
  data () {
    return {
      presentationFileUploadData:null,
      presentationFileUploadDataResults:[],
      uploadPresentationDataPopupState:false,
      removePresentationFileFromList:false,
      removePresentationFileId:''
    }
  },
  computed: {
    ...mapGetters([
      'getPresentationListGetter'
    ]),
    getPresentationFileUploadFun(){
      this.presentationFileUploadData = this.$store.getters.getPresentationListGetter.data;
      return;
    },
    setInitialStates(){
      if(this.presentationFileUploadData){
        this.presentationFileUploadDataResults = this.presentationFileUploadData.data
      }
    }
  },
  mounted () {
    bus.$on('uploadPresentationDataBus', (data) => {
      this.uploadPresentationDataPopupState = data;
    });
    this.getPresentationFileUploadFun
    this.setInitialStates
  },
  methods: {
    getPresentationDataListAgainMethod(){
      this.$store.dispatch('getPresentationListAction')
    },
    uploadPresentationDataPopupMethod(){
      this.uploadPresentationDataPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    openModalItemConfirmFun(id){
      this.removePresentationFileId = id
      this.removePresentationFileFromList = true
      document.body.classList.add('body_right_scroll_remove')
    },
    closeModalItemConfirmFun(){
      this.removePresentationFileFromList = false
      document.body.classList.remove('body_right_scroll_remove')
      this.removePresentationFileId = ''
    },
    urlClipBoardMethod(copyUrl) {
      navigator.clipboard.writeText(copyUrl);
    },
    confirmModalItemConfirmFun(){
      this.submitted =  true
      let payload = {
        title:this.removePresentationFileId
      }
      this.$store.dispatch('deletePresentationListAction', payload).then((res) => {
        this.submitted =  false
        toast.success('Presentation file deleted');
        this.getPresentationDataListAgainMethod();
        this.closeModalItemConfirmFun();
      }).catch((err) => {
        this.submitted =  false
        toast.error(err.data.data || err.data.msg);
      })
    }
  },
  watch:{
    getPresentationFileUploadFun(){
      return this.$store.getters.getPresentationListGetter
    },
    setInitialStates(){
      if(this.presentationFileUploadData){
        this.presentationFileUploadDataResults = this.presentationFileUploadData.data
      }
    }
  },
  beforeRouteLeave: function(to, from, next) {
      document.body.classList.remove('body_right_scroll_remove')
    next();
  },
}